import React, { useState, useEffect, useCallback } from "react";

import { useParams, useHistory } from "react-router";

const AddQuestions = () => {
  const [questionNM, setQuestionNM] = useState([]);
  const [pending, setPending] = useState(false);
  const [edit, setEdit] = useState(false);
  const [isQuestionsData, setIsQuestionsData] = useState({
    name: "",
    questions: [],
  });

  const { id } = useParams();
  const history = useHistory();

  const handleChangeOptions = (e, item, index) => {
    setIsQuestionsData({
      ...isQuestionsData,
      questions: [
        ...isQuestionsData.questions.map((question, i) => {
          if (i === index) {
            return {
              ...question,
              options: [
                ...question.options.map((option, ix) => {
                  if (ix === item) {
                    return {
                      ...option,
                      option_name: e.target.value,
                    };
                  } else {
                    return option;
                  }
                }),
              ],
            };
          } else {
            return question;
          }
        }),
      ],
    });
  };

  const handleChangeAnswer = (e, index) => {
    setIsQuestionsData({
      ...isQuestionsData,
      questions: [
        ...isQuestionsData.questions.map((question, i) => {
          if (i === index) {
            return {
              ...question,
              options: [...question.options],
              answer: {
                answer_name: e.target.value.slice(2),
                value: e.target.value.slice(0, 1),
              },
            };
          } else {
            return question;
          }
        }),
      ],
    });
  };

  const handleChangeQuestions = (e, index) => {
    setIsQuestionsData({
      ...isQuestionsData,
      questions: [
        ...isQuestionsData.questions.map((question, i) => {
          if (i === index) {
            return {
              ...question,
              question_name: e.target.value,
              options: [...question.options],
            };
          } else {
            return question;
          }
        }),
      ],
    });
  };

  //  set value of question name and description
  const handleStoryQuestions = (e) => {
    setIsQuestionsData({
      ...isQuestionsData,
      [e.target.name]: e.target.value,
    });
  };

  // remove question from array of questions
  const handleRemoveQuestion = (index) => {
    setIsQuestionsData({
      ...isQuestionsData,
      questions: [...isQuestionsData.questions.filter((_, i) => i !== index)],
    });
  };

  // add new question to the list of questions
  const handleAddQuestion = useCallback(() => {
    Array(questionNM.length)
      .fill()
      .map((_) => {
        return setIsQuestionsData({
          ...isQuestionsData,
          questions: [
            ...isQuestionsData.questions,
            {
              question_name: "",
              options: questionNM.map((question) => {
                return {
                  option_name: "",
                  value: question,
                };
              }),
              answer: {
                answer_name: "",
                value: "",
              },
            },
          ],
        });
      });
  }, [isQuestionsData, questionNM]);

  //  fun to submit data to server
  const handleSubmit = (e) => {
    setPending(true);
    e.preventDefault();
    // console.log(isQuestionsData);

    if (isQuestionsData.name === "" || isQuestionsData.questions.length === 0) {
      alert("Please fill all the fields");
      setPending(false);
    } else {
      if (edit) {
        fetch(`${process.env.REACT_APP_BASE_URL}/admin/quiz/${id}`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(isQuestionsData),
          credentials: "include",
        })
          .then((res) => res.json())
          .then((data) => {
            if (data.status === "success") {
              setIsQuestionsData({
                name: "",
                questions: [],
              });
              // set array of questionNM to default
              setQuestionNM([]);
              setPending(false);

              setTimeout(() => {
                setEdit(false);
                history.replace("/dashboard/all-questions");
              }, 1000);
            }
          })
          .catch((err) => {
            setPending(false);
            console.log(err);
          });
      } else {
        setEdit(false);
        fetch(`${process.env.REACT_APP_BASE_URL}/admin/quiz`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(isQuestionsData),
          credentials: "include",
        })
          .then((res) => res.json())
          .then((data) => {
            if (data.status === "success") {
              // clean data in the forms
              setIsQuestionsData({
                name: "",
                questions: [],
              });
              // set array of questionNM to default
              setQuestionNM([]);
              setPending(false);
            }
          })
          .catch((err) => {
            setPending(false);
            console.log(err);
          });
      }
    }
  };

  useEffect(() => {
    // first time render to set default value for questions
    // and get data in questionNM array then loop it  to set a default value for questions
    // and if a change in questionNM array then loop
    if (questionNM.length > 0) {
      setIsQuestionsData({
        ...isQuestionsData,
        questions: [
          ...isQuestionsData.questions,
          {
            question_name: "",
            options: questionNM.map((question, index) => {
              return {
                option_name: "",
                value: question,
              };
            }),
            answer: {
              answer_name: "",
              value: "",
            },
          },
        ],
      });
    }
  }, [questionNM]);

  useEffect(() => {
    //  get data from server , and edit it
    if (id) {
      setEdit(true);
      fetch(`${process.env.REACT_APP_BASE_URL}/admin/quiz/${id}`, {
        method: "GET",
        credentials: "include",
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status === "success") {
            setIsQuestionsData({
              name: data.msg[0].name,
              questions: data.msg[0].questions.map((item) => {
                return {
                  question_name: item.question_name,
                  answer: {
                    value: item.answer,
                    answer_name: Object.entries(item.options)
                      .flatMap((ans) => (ans[0] === item.answer ? ans[1] : []))
                      .join(""),
                  },
                  options: Object.entries(item.options).map((opt) => {
                    return {
                      value: opt[0],
                      option_name: opt[1],
                    };
                  }),
                };
              }),
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [id]);

  const changeRouter = window.location.pathname.split("/")[2];

  useEffect(() => {
    // if change router to add questions then  set default value for questions
    if (changeRouter === "add-questions") {
      setIsQuestionsData({
        name: "",
        questions: [],
      });
      setQuestionNM([]);
      setPending(false);
      setEdit(false);
    }
  }, [changeRouter]);

  return (
    <section className="mt-4 section-add-questions">
      <div className="container">
        <div className="row">
          <div className="col-md-10 m-auto">
            <h2>Add Questions</h2>
            <form className="form-add-questions" onSubmit={handleSubmit}>
              <div className="form-group mt-3">
                <label className="mb-2"> Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter  Name"
                  value={isQuestionsData.name}
                  onChange={handleStoryQuestions}
                  name="name"
                />
              </div>

              <div className="form-group mt-3">
                <label className="mb-2"> Question answer number</label>
                <select
                  className="form-select"
                  onChange={(e) => {
                    const value = [...e.target.value].filter((str) =>
                      /\S/.test(str)
                    );
                    setQuestionNM(value);
                  }}
                >
                  <option value=""></option>
                  <option>A B</option>
                  <option>A B C</option>
                  <option>A B C D</option>
                  <option>A B C D F</option>
                </select>
              </div>
              <>
                {isQuestionsData.questions.map((_question, index) => (
                  <div key={index} className="question-group">
                    <div className="form-group ">
                      <label className="mb-2"> Question Name {index + 1}</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Question Name"
                        onChange={(e) => handleChangeQuestions(e, index)}
                        value={_question.question_name}
                      />
                    </div>

                    {_question.options.map((option, item) => (
                      <div key={item} className="form-group mt-2">
                        <div className="question-group_option">
                          <label className="mb-2">{option.value}</label>
                          <input
                            type="radio"
                            name={`answer${index}`}
                            value={[option.value, option.option_name]}
                            checked={_question.answer.value === option.value}
                            onChange={(e) => {
                              handleChangeAnswer(e, index);
                            }}
                          />
                          <input
                            type="text"
                            className="form-control"
                            placeholder={`Enter Answer ${option.value}`}
                            onChange={(e) => {
                              handleChangeOptions(e, item, index);
                            }}
                            value={option.option_name}
                          />
                        </div>
                      </div>
                    ))}

                    <div className="question-group_btn">
                      <button
                        className="btn btn-primary"
                        onClick={handleAddQuestion}
                        type="button"
                        aria-label="add question"
                        data-toggle="tooltip"
                        title="Add Question"
                      >
                        Add Question
                      </button>

                      <button
                        type="button"
                        className="btn btn-danger"
                        aria-label="remove question"
                        data-toggle="tooltip"
                        title="Remove Question"
                        onClick={() => handleRemoveQuestion(index)}
                      >
                        Remove Question
                      </button>
                    </div>
                  </div>
                ))}
              </>
              <div>
                <button
                  className="contButSmall"
                  type="submit"
                  aria-label="save"
                  data-toggle="tooltip"
                  title="save"
                >
                  {pending ? (
                    <div className="spinner-border" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  ) : (
                    <span> {edit ? "Edit" : "save"}</span>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AddQuestions;
